module.exports = __webpack_public_path__ + "img/10.3d178d95.jpg";